import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ThemeContext from '../../../theme/ThemeContext';
import DecoratorSettings from './DecoratorSettings';
import { StyledFieldWrapper, StyledFieldLabel } from './SettingsCommonElements';
import { mergeRowDecorators } from '../../../lib/decoratorHelper';

const StyledSelect = styled.select`
  padding: 4px 6px;
  font-size: 12px;
  border-radius: ${(props) => props.theme?.borderRadius || 5}px;
  border: 1px solid ${(props) => props.theme?.borderColor || '#d9d9d9'};
  background-color: #fff;
  cursor: pointer;
  width: 100%;
`;

const RowSpecificDecoratorSettings = ({
  rows,
  rowOrder,
  rowCommonDecorators,
  onCreate,
  onChange,
  onDelete,
}) => {
  const theme = useContext(ThemeContext);
  const [selectedRowId, setSelectedRowId] = useState('');

  const orderedRows = rowOrder
    ? rowOrder.map((id) => (rows || []).find((r) => r._id === id)).filter(Boolean)
    : (rows || []).filter((r) => !r.deleted);

  const selectedRow = selectedRowId
    ? orderedRows.find((r) => r._id === selectedRowId)
    : null;

  const displayDecorators = mergeRowDecorators(
    rowCommonDecorators,
    selectedRow?.decorators?.all
  );

  return (
    <>
      <StyledFieldWrapper>
        <StyledFieldLabel>Select Row</StyledFieldLabel>
        <StyledSelect
          theme={theme}
          value={selectedRowId}
          onChange={(e) => setSelectedRowId(e.target.value)}
        >
          <option value="">-- Choose a row --</option>
          {orderedRows.map((row, index) => (
            <option key={row._id} value={row._id}>
              Row {index + 1}
            </option>
          ))}
        </StyledSelect>
      </StyledFieldWrapper>
      {selectedRow ? (
        <DecoratorSettings
          decorators={displayDecorators}
          onCreate={(data) => onCreate(selectedRowId, data)}
          onChange={(decoratorAction, data) => onChange(selectedRowId, decoratorAction, data)}
          onDelete={(decoratorAction) => onDelete(selectedRowId, decoratorAction)}
        />
      ) : null}
    </>
  );
};

RowSpecificDecoratorSettings.propTypes = {
  rows: PropTypes.array,
  rowOrder: PropTypes.array,
  rowCommonDecorators: PropTypes.array,
  onCreate: PropTypes.func,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
};

export default RowSpecificDecoratorSettings;
